import React from 'react';
import { Button } from 'reactstrap';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

function ItemFailedToLoad({ showGoBackButton, error }) {
  const { t } = useTranslation();
  const { goBack } = useHistory();

  return (
    <div className="fullscreen-placeholder">
      <div className="d-flex flex-column">
        <h1>{t('general.error', { error })}</h1>
        {showGoBackButton && (
          <Button
            className="btn-icon btn-3"
            color="default"
            type="button"
            onClick={goBack}
          >
            <span className="btn-inner--text">{t('general.go_back')}</span>
          </Button>
        )}
      </div>
    </div>
  );
}

ItemFailedToLoad.propTypes = {
  showGoBackButton: PropTypes.bool,
  error: PropTypes.shape({
    message: PropTypes.string.isRequired
  }).isRequired
};

ItemFailedToLoad.defaultProps = {
  showGoBackButton: false
};

export default ItemFailedToLoad;
